import { Directive, HostListener, Input, inject } from '@angular/core';
import { IS_PRODUCTION } from '@rma/generic/util/environment';
import { Subject, filter, switchMap, throttleTime } from 'rxjs';
import { ClixelService, TrixelInteraction } from '../domain/services/clixel.service';

@Directive({
  selector: '[rmaClixel]',
  standalone: true,
})
export class ClixelDirective {
  readonly clixelService = inject(ClixelService);

  @Input() public rmaClixel?: string;
  @Input() public sourceCategory?: string;
  @Input() public interaction?: TrixelInteraction;
  @Input() public trixelReferringSourceCategory?: string;
  @Input() public clixelDisabled = false;

  @HostListener('click')
  public onClick() {
    if (!this.clixelDisabled) {
      if (this.rmaClixel) {
        this.clicks.next();
      } else if (!IS_PRODUCTION) {
        throw new Error('No url passed to clixel');
      }
    }
  }

  private clicks = new Subject<void>();

  public constructor() {
    const clixelService = this.clixelService;

    this.clicks
      .asObservable()
      .pipe(
        throttleTime(600),
        filter(() => Boolean(this.rmaClixel)),
        switchMap(() =>
          clixelService.logEventInTrixels(
            this.rmaClixel as string,
            this.sourceCategory,
            this.interaction,
            this.trixelReferringSourceCategory,
          ),
        ),
      )
      .subscribe();
  }
}
